import CircularProgress from "@mui/material/CircularProgress";
import React from 'react';
import { replaceStrongTags } from "utils/replaceHtml";
import "./index.scss";

const Templates = ({
  templateContent,
  isLoading,
  showTitle = true,
  disableLinks = false,
}) => {


  const replacedHtml = replaceStrongTags(templateContent);
  return (
    <div className="templates">
      {showTitle && (
        <>
          <div className="templates__head">
            <h3 className="templates-title">
              Templates
            </h3>
          </div>
          <hr />
        </>
      )}
      <div className="templates__content">
        {isLoading ? (
          <div className="w-100 text-center">
            <CircularProgress />
          </div>
        ) : templateContent ? (
          <p
            className={disableLinks ? 'templates__content__disable-links' : ''}
            dangerouslySetInnerHTML={{ __html: replacedHtml }}
            onClick={disableLinks ? (e) => { if (e.target.tagName === 'A') e.preventDefault(); } : undefined}
          />
        ) : (
          <div className="templates__content-no-data">No Template</div>
        )}

      </div>
    </div>
  )
}

export default Templates